import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { RestResponse } from "../classes/rest-response";
import { ApiHeaders } from "../classes/api-headers";

@Injectable({
  providedIn: 'root'
})
export class MainProvider {
  baseUrl: string = environment.BASE_URL;
  baseUrl2: string = environment.BASE_URL2;

  constructor(private http: HttpClient) {
  }

  logoutAdmin(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminUpdate`, formData);
  }

  AdminControl(formData: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/AdminControl`, formData);
  }
  // Admin APIs

  refreshToken(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/auth/refresh-token`, obj, ApiHeaders.getOptions());
  }

  logoutUser(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/auth/logout`, obj, ApiHeaders.getOptions());
  }

  // Category APIs

  getCategoryList(id: number, status: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/categories?id=${id}&status=${status}`, ApiHeaders.getOptions());
  }

  addMenuCategory(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/categories`, obj, ApiHeaders.getOptions());
  }

  updateMenuCategory(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/categories`, obj, ApiHeaders.getOptions());
  }

  // Menu Items APIs

  getMenuItems(id: number, category_id: number | '', status: string, search: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/menu-item?id=${id}&category_id=${category_id}&stock_status=${status}&search=${search}`, ApiHeaders.getOptions());
  }

  addMenuItem(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/menu-item`, obj, ApiHeaders.getOptions());
  }

  updateMenuItem(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/menu-item`, obj, ApiHeaders.getOptions());
  }

  // Ingredients APIs

  getIngredientsList(ingredient_id: number, ingredient_name: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/ingredients?ingredient_id=${ingredient_id}&ingredient_name=${ingredient_name}`, ApiHeaders.getOptions());
  }

  addIngredient(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/ingredients`, obj, ApiHeaders.getOptions());
  }

  updateIngredient(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/ingredients`, obj, ApiHeaders.getOptions());
  }

  // Customers APIs

  getCustomerList(customer_id: number, phone_number: string, customer_name: string, email: string, date_of_birth: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/customer?customer_id=${customer_id}&phone_number=${phone_number}&customer_name=${customer_name}&email=${email}&date_of_birth=${date_of_birth}`, ApiHeaders.getOptions());
  }

  addCustomer(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/customer`, obj, ApiHeaders.getOptions());
  }

  updateCustomer(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/customer`, obj, ApiHeaders.getOptions());
  }

  // Tables APIs

  getTableList(table_id: number, table_number: string, status: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/table?table_id=${table_id}&table_number=${table_number}&status=${status}`, ApiHeaders.getOptions());
  }

  addTable(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/table`, obj, ApiHeaders.getOptions());
  }

  updateTable(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/table`, obj, ApiHeaders.getOptions());
  }

  // Staff APIs

  getStaffList(staff_id: number, phone_number: string, role: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/staff?staff_id=${staff_id}&phone_number=${phone_number}&role=${role}`, ApiHeaders.getOptions());
  }

  addStaff(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/staff`, obj, ApiHeaders.getOptions());
  }

  updateStaff(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/staff`, obj, ApiHeaders.getOptions());
  }

  // Menu Items Recipe APIs

  getMenuItemRecipe(recipe_id: number, menu_item_id: number, ingredient_id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/menu-item-recipe?recipe_id=${recipe_id}&menu_item_id=${menu_item_id}&ingredient_id=${ingredient_id}`, ApiHeaders.getOptions());
  }

  saveMenuItemRecipe(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/menu-item-recipe`, obj, ApiHeaders.getOptions());
  }

  // Live Billing APIs

  getTableWiseOrders(table_id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/generate-order?table_id=${table_id}`, ApiHeaders.getOptions());
  }

  saveOrderFirstTime(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/generate-order`, obj, ApiHeaders.getOptions());
  }

  getTableWaitingList(queue_status: string, customer_name: string, phone_number: string, queue_id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/waiting-list?queue_status=${queue_status}&customer_name=${customer_name}&phone_number=${phone_number}&queue_id=${queue_id}`, ApiHeaders.getOptions());
  }

  addWaiting(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/waiting-list`, obj, ApiHeaders.getOptions());
  }

  updateWaiting(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/waiting-list`, obj, ApiHeaders.getOptions());
  }

  printBill(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/print-bill`, obj, ApiHeaders.getOptions());
  }

  DeleteKOT(kot_id: number, order_id: number): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/kot?kot_id=${kot_id}&order_id=${order_id}`, ApiHeaders.getOptions());
  }

  // Bill History APIs

  getBillOrderHistory(from_date: string, to_date: string, phone_number: string, bill_id: number, waiter_id: number, table_id: number, status: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/bill-history?from_date=${from_date}&to_date=${to_date}&phone_number=${phone_number}&bill_id=${bill_id}&waiter_id=${waiter_id}&table_id=${table_id}&status=${status}`, ApiHeaders.getOptions());
  }

  cancelBill(bill_id: number, staff_id: number, void_pin: string, void_reason: string): Observable<RestResponse> {
    return this.http.delete<RestResponse>(this.baseUrl + `/generate-order?bill_id=${bill_id}&staff_id=${staff_id}&void_pin=${encodeURIComponent(void_pin)}&void_reason=${encodeURIComponent(void_reason)}`, ApiHeaders.getOptions());
  }

  AddDiscountToBill(obj: any): Observable<RestResponse> {
    return this.http.put<RestResponse>(this.baseUrl + `/discount-after-bill`, obj, ApiHeaders.getOptions());
  }

  // Live Orders APIs

  getKOTList(status: string, kot_id: number, order_id: number = 0): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/kot?kot_status=${status}&kot_id=${kot_id}&order_id=${order_id}`, ApiHeaders.getOptions());
  }

  updateKOTStatus(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/kot`, obj, ApiHeaders.getOptions());
  }

  printKOT(obj: any): Observable<RestResponse> {
    return this.http.post<RestResponse>(this.baseUrl + `/print-kot`, obj, ApiHeaders.getOptions());
  }

  // Dashboard APIs

  getDashboardData(): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/dashboard`, ApiHeaders.getOptions());
  }

  getDashboardChartData(chart_type: string, from_date: string, to_date: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/chart?chart_type=${chart_type}&from_date=${from_date}&to_date=${to_date}`, ApiHeaders.getOptions());
  }

  getHistoricalData(chart_type: string, scale: string, from_date: string, to_date: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/chart?chart_type=${chart_type}&scale=${scale}&from_date=${from_date}&to_date=${to_date}`, ApiHeaders.getOptions());
  }

  // Reports APIs

  getOverallRevenueSummaryReport(report_type: string, from_date: string, to_date: string, payment_mode: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/business-operations?report_type=${report_type}&from_date=${from_date}&to_date=${to_date}&payment_mode=${payment_mode}`, ApiHeaders.getOptions());
  }

  getProductPerfomanceReport(report_type: string, from_date: string, to_date: string, category_id: number, sort_by: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/business-operations?report_type=${report_type}&from_date=${from_date}&to_date=${to_date}&category_id=${category_id}&sort_by=${sort_by}`, ApiHeaders.getOptions());
  }

  getStaffPerfomanceReport(report_type: string, from_date: string, to_date: string, staff_id: number): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/business-operations?report_type=${report_type}&from_date=${from_date}&to_date=${to_date}&staff_id=${staff_id}`, ApiHeaders.getOptions());
  }

  getCRMInsightsReport(report_type: string, from_date: string, to_date: string, phone_number: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/business-operations?report_type=${report_type}&from_date=${from_date}&to_date=${to_date}&phone_number=${phone_number}`, ApiHeaders.getOptions());
  }

  getTableWiseSalesReport(table_id: number, table_zone: string, from_date: string, to_date: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(this.baseUrl + `/reports/table-wise-sales?table_id=${table_id}&table_zone=${table_zone}&from_date=${from_date}&to_date=${to_date}`, ApiHeaders.getOptions());
  }
}
